import { render, staticRenderFns } from "./SMTP.vue?vue&type=template&id=2ddac34e&scoped=true&"
import script from "./SMTP.vue?vue&type=script&lang=js&"
export * from "./SMTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddac34e",
  null
  
)

export default component.exports